import { AttachmentResult, AttachmentType } from '@sdir/httpclient/lib/clients/aps/application';
import React, { useCallback, useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { routes } from '../../../constants/routes';
import { editRouteForAttachmentType } from '../../../helpers/Qualifications';
import { AttachmentsButton } from '../../Atoms';
import { useNavigateWithLang } from '../../../services/hooks/useNavigateWithLang';

interface ExistingGroupActionProps {
  applicationUid: string;
  attachmentGroup: string;
  type: AttachmentType;
  attachments: AttachmentResult[];
}

export const ExistingGroupAction: React.FC<ExistingGroupActionProps> = ({
  applicationUid,
  attachmentGroup,
  type,
  attachments,
}) => {
  const navigate = useNavigateWithLang();

  const editRoute = useMemo(() => editRouteForAttachmentType(type), [type]);

  const handleClick = useCallback(() => {
    navigate(
      generatePath(editRoute || routes.application.addFiles, { applicationUid, attachmentGroup })
    );
  }, [applicationUid, attachmentGroup, editRoute, navigate]);

  if (!editRoute && !attachments.length) return null;

  return <AttachmentsButton attachments={attachments} onClick={handleClick} />;
};
